import ArrowBackIcon from '@material-ui/icons/KeyboardBackspace';
import ArrowForwardIcon from './ArrowForwardIcon';

export { ArrowBackIcon, ArrowForwardIcon };
